<section class="page-stack">
  <div class="page-heading">
    <div>
      <span class="eyebrow">Movimientos HPG</span>
      <h2>Transacciones</h2>
    </div>
    <button class="primary-button" type="button" [disabled]="loading" (click)="load()">Actualizar</button>
  </div>

  <form class="panel filter-panel" (ngSubmit)="applyFilters()">
    <div class="panel-header">
      <div>
        <span class="eyebrow">Filtros</span>
        <h3>Busqueda avanzada</h3>
      </div>
      <div class="header-actions">
        <button class="ghost-button" type="button" [disabled]="loading" (click)="clearFilters()">Limpiar</button>
        <button
          class="icon-button collapse-button"
          type="button"
          (click)="filtersOpen = !filtersOpen"
          [attr.aria-expanded]="filtersOpen"
          aria-controls="hpgFilters">
          {{ filtersOpen ? '⌃' : '⌄' }}
        </button>
      </div>
    </div>

    <div id="hpgFilters" class="collapsible" [class.open]="filtersOpen">
    <div class="filter-grid">
      <label>ID <input type="number" name="id" [(ngModel)]="filters['id']"></label>
      <label>Solicitud Pago <input type="number" name="solicitudPago" [(ngModel)]="filters['solicitudPago']"></label>
      <label>Trx ID <input type="text" name="transaction_id" [(ngModel)]="filters['transaction_id']"></label>
      <label>Terminal <input name="terminalId" [(ngModel)]="filters['terminalId']"></label>
      <label>Autorizacion <input name="authorizationCode" [(ngModel)]="filters['authorizationCode']"></label>
      <label>Método de pago
        <select name="paymentMethod" [(ngModel)]="filters['paymentMethod']">
          <option value="">Todos</option>
          <option *ngFor="let item of paymentMethods" [value]="item.value">{{ item.label }}</option>
        </select>
      </label>
      <label>ID procesador <input name="identificadorProcesador" [(ngModel)]="filters['identificadorProcesador']"></label>
      <label>Wallet <input name="wallet" placeholder="Ej.: Mercado Pago" [(ngModel)]="filters['wallet']"></label>
      <label>ID orden de venta <input name="idOrdenVenta" inputmode="numeric" pattern="[0-9]+" [(ngModel)]="filters['idOrdenVenta']"></label>
      <label>Fecha desde <input type="date" name="dateFrom" [(ngModel)]="filters['dateFrom']"></label>
      <label>Fecha hasta <input type="date" name="dateTo" [(ngModel)]="filters['dateTo']"></label>
      <label>Estado
        <select name="transactionStatus" multiple [(ngModel)]="filters['transactionStatus']">
          <option *ngFor="let item of statuses" [value]="item">{{ item }}</option>
        </select>
      </label>
      <label>Adquirente
        <select name="acquirer" multiple [(ngModel)]="filters['acquirer']">
          <option *ngFor="let item of acquirers" [value]="item">{{ item }}</option>
        </select>
      </label>
      <label>Marca
        <select name="cardBrand" multiple [(ngModel)]="filters['cardBrand']">
          <option *ngFor="let item of brands" [value]="item">{{ item }}</option>
        </select>
      </label>
      <label>Card Type
        <select name="cardType" multiple [(ngModel)]="filters['cardType']">
          <option *ngFor="let item of cardTypes" [value]="item">{{ item }}</option>
        </select>
      </label>
      <label>Entry Mode
        <select name="posEntryMode" multiple [(ngModel)]="filters['posEntryMode']">
          <option *ngFor="let item of entryModes" [value]="item">{{ item }}</option>
        </select>
      </label>
      <label>Origen
        <select name="transactionOriginType" multiple [(ngModel)]="filters['transactionOriginType']">
          <option *ngFor="let item of origins" [value]="item">{{ item }}</option>
        </select>
      </label>
      <label>Operacion
        <select name="transactionContext" multiple [(ngModel)]="filters['transactionContext']">
          <option *ngFor="let item of contexts" [value]="item">{{ item }}</option>
        </select>
      </label>
      <label>Tipo Proceso
        <select name="paymentProcessType" multiple [(ngModel)]="filters['paymentProcessType']">
          <option *ngFor="let item of processTypes" [value]="item">{{ item }}</option>
        </select>
      </label>
    </div>

    <div class="table-actions">
      <button class="primary-button" type="submit" [disabled]="loading">Buscar</button>
    </div>
    </div>
  </form>

  <div class="panel">
    <div class="panel-header">
      <div>
        <span class="eyebrow">{{ total }} registros</span>
        <h3>Listado de movimientos</h3>
      </div>
      <label class="inline-control">Filas
        <select name="size" [(ngModel)]="size" [disabled]="loading" (ngModelChange)="page = 0; load()">
          <option *ngFor="let option of pageSizes" [value]="option">{{ option }}</option>
        </select>
      </label>
    </div>

    <div class="state error" *ngIf="error">{{ error }}</div>
    <div class="state" *ngIf="loading">Cargando transacciones...</div>

    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>ID</th><th>Trx ID</th><th>Terminal</th><th>SP</th><th>Fecha</th><th>Monto</th>
            <th>Adquirente</th><th>Marca</th><th>Card Type</th><th>Payment</th><th>Operacion</th><th>Status</th><th>Tarjeta</th>
            <th>Entry</th><th>Aut.</th><th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rows">
            <td>{{ row.id }}</td>
            <td>{{ text(row.transactionId) }}</td>
            <td>{{ text(row.terminalId) }}</td>
            <td>{{ text(row.solicitudPago) }}</td>
            <td>{{ dateTime(row.transactionDateTime) }}</td>
            <td>{{ moneyFromCents(row.amountTransaction) }}</td>
            <td>{{ text(row.acquirer) }}</td>
            <td><img class="brand-logo" [src]="brandImage(row.cardBrand)" alt="" onerror="this.src='/img/brands/unknown.png'"></td>
            <td>{{ text(row.cardType) }}</td>
            <td>{{ text(row.paymentMethod) }}</td>
            <td>{{ text(row.transactionContext) }}</td>
            <td><span [class]="statusClass(row.transactionStatus)">{{ text(row.transactionStatus) }}</span></td>
            <td>{{ text(row.card) }}</td>
            <td><span class="badge info">{{ text(row.posEntryMode) }}</span></td>
            <td>{{ text(row.authorizationCode) }}</td>
            <td><button class="icon-button" type="button" (click)="openDetail(row.id)">Ver</button></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <span class="pagination-status">
        <span class="loading-spinner" *ngIf="loading" aria-hidden="true"></span>
        Pagina {{ page + 1 }} de {{ totalPages }}
      </span>
      <div class="pagination-actions">
        <button class="ghost-button" type="button" [disabled]="loading || page === 0" (click)="changePage(-1)">Anterior</button>
        <div class="page-buttons" aria-label="Paginas">
          <ng-container *ngFor="let item of visiblePages()">
            <span class="page-ellipsis" *ngIf="item === 'ellipsis'">...</span>
            <button
              *ngIf="item !== 'ellipsis'"
              class="page-button"
              type="button"
              [disabled]="loading"
              [class.active]="page === item"
              [attr.aria-current]="page === item ? 'page' : null"
              (click)="goToPage(item)">
              {{ item + 1 }}
            </button>
          </ng-container>
        </div>
        <button class="ghost-button" type="button" [disabled]="loading || page + 1 >= totalPages" (click)="changePage(1)">Siguiente</button>
      </div>
    </div>
  </div>
</section>

<div class="modal-backdrop" *ngIf="detail || detailLoading" (click)="closeDetail()">
  <article class="modal transaction-detail-modal" (click)="$event.stopPropagation()">
    <header class="detail-header">
      <div>
        <span class="eyebrow">Detalle de transaccion</span>
        <h3>#{{ text(detailValue('id')) }} · {{ text(detailValue('transactionId')) }}</h3>
      </div>
      <button class="icon-button" type="button" (click)="closeDetail()">Cerrar</button>
    </header>

    <div class="state loading-state" *ngIf="detailLoading">
      <span class="loading-spinner" aria-hidden="true"></span>
      Cargando detalle...
    </div>

    <ng-container *ngIf="detail">
      <div class="detail-summary">
        <div>
          <span>Estado</span>
          <strong [class]="statusClass(detailValue('transactionStatus'))">
            {{ text(detailValue('transactionStatus')) }}
          </strong>
        </div>
        <div>
          <span>Monto</span>
          <strong>{{ formatDetailValue('amountTransaction') }}</strong>
        </div>
        <div>
          <span>Fecha</span>
          <strong>{{ formatDetailValue('transactionDateTime') }}</strong>
        </div>
        <div>
          <span>Terminal</span>
          <strong>{{ text(detailValue('terminalId')) }}</strong>
        </div>
      </div>

      <nav class="detail-tabs" aria-label="Secciones del detalle">
        <button
          *ngFor="let tab of detailTabs"
          type="button"
          class="detail-tab"
          [class.active]="activeDetailTab === tab.id"
          (click)="activeDetailTab = tab.id">
          <span class="detail-tab-icon"><ng-icon [name]="detailIcon(tab.icon)" /></span>
          {{ tab.label }}
        </button>
      </nav>

      <div class="state loading-state" *ngIf="activeDetailTab === 'plan' && planLoading">
        <span class="loading-spinner" aria-hidden="true"></span>
        Cargando plan...
      </div>

      <div class="state error" *ngIf="activeDetailTab === 'plan' && planError">{{ planError }}</div>

      <div class="detail-grid compact" *ngIf="activeDetailTab !== 'plan' || (!planLoading && !planError)">
        <div class="detail-item" *ngFor="let item of activeDetailItems()">
          <span class="detail-icon"><ng-icon [name]="detailIcon(item.icon)" /></span>
          <div>
            <span>{{ item.label }}</span>
            <strong>{{ formatDetailValue(item.key) }}</strong>
          </div>
        </div>
      </div>

      <div class="state" *ngIf="!planLoading && !planError && activeDetailItems().length === 0">
        {{ activeDetailTab === 'plan' && !hasAssociatedPlan() ? 'La transaccion no tiene un plan asociado.' : 'Sin datos para esta seccion.' }}
      </div>
    </ng-container>
  </article>
</div>
